import { render, staticRenderFns } from "./SFormUserComp.vue?vue&type=template&id=899ddf1e&"
import script from "./SFormUserComp.vue?vue&type=script&lang=js&"
export * from "./SFormUserComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports